import moment from 'moment'

export function formatTimeStamp(dateTimeUtc: string) {
  return moment.utc(dateTimeUtc).local().format('DD.MM.YYYY - HH:mm:ss')
}
